var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTestDrivePlanned = function SvgIconTestDrivePlanned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.6,
    r: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.4v2.2l1.7 1.1M3 21.8c2.8-2.7 5.8-4.1 9-4.1s6.2 1.4 9 4.1"
  }))));
};
export default SvgIconTestDrivePlanned;